<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'lager']"> <i class="fa fa-building-o"></i> Lager </a>
      </li>
      <li>
        <a> Rücksendebeauftragung </a>
      </li>
    </ul>
  </div>
</div>
<div class="page-content page-frame overflow-auto">
  <div class="page-sheet max-w-xl mx-auto">
    <p class="p-4">
      Hier können Rücksendeaufträge erfasst werden. Nach dem Absenden werden diese oberhalb des Formulars angezeigt und
      mit einem Klick auf den Lieferschein kann die bereits erzeugte Versandmarke abgerufen werden.
    </p>
    @if (returnJobs()?.length) {
      <div class="bm-card-title">Gerade erfasse Aufträge</div>
      <table class="bm-table bm-table-xs w-full">
        <tr>
          <td>Absender</td>
          <td>Gewicht</td>
          <td>Länge</td>
          <td>Breite</td>
          <td>Höhe</td>
          <td>Lieferschein</td>
        </tr>
        @for (job of returnJobs(); track $index) {
          <tr>
            <td>{{ job.sender_address_company }}</td>
            <td>{{ job.parcel_weight }}</td>
            <td>{{ job.parcel_length }}</td>
            <td>{{ job.parcel_width }}</td>
            <td>{{ job.parcel_height }}</td>
            <td>
              <a href="/a/lieferscheine/{{ job.id }}" target="_blank">Zum Lieferschein {{ job.id }}</a>
            </td>
          </tr>
        }
      </table>
    }

    <form [formGroup]="form" (submit)="onSubmit()" class="w-full">
      <fieldset class="bm-fieldset p-4">
        <legend class="bm-fieldset-legend text-lg">Neuen Auftrag anlegen</legend>
        <label class="bm-fieldset-label">Lager ID Absender</label>
        <input class="bm-input w-full" placeholder="Lager ID" formControlName="warehouse_id" />
        <label class="bm-fieldset-label">Paket Gewicht</label>
        <input class="bm-input w-full" type="number" placeholder="Gewicht in kg" formControlName="parcel_weight" />
        <label class="bm-fieldset-label">Paket Länge</label>
        <input class="bm-input w-full" type="number" placeholder="Länge in cm" formControlName="parcel_length" />
        <label class="bm-fieldset-label">Paket Breite</label>
        <input class="bm-input w-full" type="number" placeholder="Breite in cm" formControlName="parcel_width" />
        <label class="bm-fieldset-label">Paket Höhe</label>
        <input class="bm-input w-full" type="number" placeholder="Höhe in cm" formControlName="parcel_height" />

        <button type="submit" class="bm-btn bm-btn-primary bm-btn-block mt-4" [disabled]="status() === 'sending'">
          @if (status() === "sending") {
            <span class="bm-loading bm-loading-spinner bm-loading-sm"></span>
          } @else {
            Beauftragen!
          }
        </button>
        @if (errorText(); as text) {
          <div role="alert" class="bm-alert bm-alert-error bm-alert-soft bm-alert-vertical sm:bm-alert-horizontal">
            <span></span>
            <div>
              <div class="font-bold text-lg">Fehler!</div>
              <div class="text-xs">
                {{ text }}
              </div>
            </div>
          </div>
        }
      </fieldset>
    </form>
  </div>
</div>
